import React, { useState, useEffect, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router-dom";
import { Field, Form, Formik, useFormikContext } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import {
  isAfter,
  parse,
  isValid,
  format,
  isBefore,
  isEqual,
  isWithinInterval,
  add,
  intervalToDuration,
} from "date-fns";

import {
  Flex,
  Text,
  Button,
  FormControl,
  FormErrorMessage,
  HStack,
  Tooltip,
  Icon,
  Box,
} from "@chakra-ui/react";

import { IoHelpCircle } from "react-icons/io5";

import { Identificacao } from "./Identificacao";
import { Filiacao } from "./Filiacao";

import CriancaService from "../../../../main/services/CriancaService";
import { API } from "../../../../main/config";
import { hasFormChanged } from "../../../utils/hasFormChanged";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { getBase64 } from "../../../components/Base64";
import { normalizeString } from "../../../utils/masks";
import { useAuth } from "react-oidc-context";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { scrollToFieldAnexo } from "../../../utils/scrollToFIeldAnexo";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { criancaFunc } from "../../../../helpers/Funcionalidades";
import SemRegistros from "../../../components/SemRegistros";

export const EditarCrianca = () => {
  const { id } = useParams();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");
  const idTipoPendencia = searchParams.get("idTipoPendencia");

  const history = useHistory();
  const keycloak = useAuth();

  const { roleKeycloack, user } = useAuthProvider();

  const {
    setEditarCriancaCr,
    houveExtincaoPoderFamiliar,
    setFiliacao,
    movimentacoesPendente,
  } = useAppContext();
  const suportedImageFormats = [
    "image/jpg",
    "image/jpeg",
    "image/tiff",
    "image/png",
    "image/bmp",
  ];

  const [defaultImage, setDefaultImage] = useState("");
  const [removeu, setRemoveu] = useState(false);
  const [defaultFoto, setDefaultFoto] = useState();
  const [, setFoto] = useState();
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);

  const [idAnexoFoto, setIdAnexoFoto] = useState(null);
  const [dataMovimentacao, setDataMovimentacao] = useState("");
  const [movimentacaoFlag, setMovimentacaoFlag] = useState("");

  const [dataCrianca, setDataCrianca] = useState();

  const [initialValues, setInitialValues] = useState({
    anexos: null,
    foto: null,
    nome: "",
    nomeFicticio: false,
    nomeNaoInformado: false,
    dataFoto: "",
    nomeSocial: "",
    idGenero: "",
    genero: {},
    dataNascimento: "",
    dataNascimentoEstimada: false,
    idRaca: "",
    nacionalidade: "",
    idNaturalidade: "",
    tipoSanguineo: {},
    filiacoes: [],
    situacaoMae: "",
    situacaoPai: "",
    arquivoBase64: null,
  });

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idAnexo || idTipoPendencia, ref);
    },
    [idAnexo, idTipoPendencia],
  );

  useEffect(() => {
    setLoading(true);

    CriancaService.getCrianca(id)
      .then((res) => {
        const {
          nomeSocial,
          nome,
          nomeFicticio,
          nomeNaoInformado,
          anexos,
          dataNascimentoEstimada,
          foto,
          dataFoto,
          genero,
          idGenero,
          dataNascimento,
          raca,
          nacionalidade,
          naturalidade,
          tipoSanguineo,
          filiacoes,
          servicoAcolhimento,
          movimentacoes,
          idAnexoFoto,
          ...resto
        } = res.data;

        setDataCrianca(res.data);
        setFiliacao(res.data.filiacoes);

        const movimentacaoDate = movimentacoes.sort(
          (a, b) => a.dataMovimentacao - b.dataMovimentacao,
        );
        const movimentacaoDateFlag = movimentacoes
          .filter((item) => item?.motivoSituacao?.extincaoPoderFamiliar === "S")
          .sort((a, b) => a.ordem - b.ordem);

        const paiDescSI = filiacoes.find((filiacao) => {
          return (
            filiacao.tipoFiliacao === "Pai" &&
            (filiacao.filiacao.nome === "Desconhecido" ||
              normalizeString(filiacao.filiacao.nome) ===
                normalizeString("Sem informação"))
          );
        });

        const maeDescSI = filiacoes.find((filiacao) => {
          return (
            filiacao.tipoFiliacao === "Mãe" &&
            (filiacao.filiacao.nome === "Desconhecida" ||
              normalizeString(filiacao.filiacao.nome) ===
                normalizeString("Sem informação"))
          );
        });

        anexos.sort((a, b) => new Date(b.dataUpload) - new Date(a.dataUpload));
        setDefaultImage(API + `/criancas/anexos/${idAnexoFoto}/visualizar`);
        setDefaultFoto(anexos);
        setIdAnexoFoto(idAnexoFoto);

        setDataMovimentacao(movimentacaoDate[0].dataMovimentacao);
        setMovimentacaoFlag(movimentacaoDateFlag[0]);
        setInitialValues({
          ...resto,
          nome: nome ? nome.replace("(Nome Fictício)", "").trim() : "",
          nomeSocial: nomeSocial ? nomeSocial : "",
          anexos: null,
          foto: null,
          nomeFicticio: nomeFicticio === "S" ? ["Possui"] : [],
          nomeNaoInformado: nomeNaoInformado === "S" ? ["Possui"] : [],
          dataNascimentoEstimada: dataNascimentoEstimada === "S",

          idGenero: genero
            ? {
                id: genero.id,
                label: (
                  <HStack justifyContent="space-between" px={{ md: "16px" }}>
                    <Text
                      color="#1A203D"
                      fontWeight={400}
                      fontSize={{ base: "12px", md: "14px" }}
                    >
                      {genero.genero}
                    </Text>
                    <Tooltip label={genero.descricao} fontSize="md">
                      <span>
                        <Icon
                          aria-label="Aviso de pendente"
                          color="#6B6C71"
                          as={IoHelpCircle}
                          boxSize={{ base: "10px", md: "20px" }}
                        />
                      </span>
                    </Tooltip>
                  </HStack>
                ),
              }
            : "",
          dataNascimento: dataNascimento
            ? format(new Date(dataNascimento), "dd/MM/yyyy")
            : "",
          dataFoto: dataFoto ? format(new Date(dataFoto), "dd/MM/yyyy") : "",
          idRaca: raca ? raca : "",
          idNaturalidade: naturalidade ? naturalidade : "",
          idTipoSanguineo: tipoSanguineo ? tipoSanguineo : "",
          tipoSanguineo: tipoSanguineo ? tipoSanguineo : null,
          genero: genero ? genero : "",
          raca,
          nacionalidade: nacionalidade,
          naturalidade,
          filiacoes: filiacoes
            ? filiacoes.map((filiacao) => filiacao.filiacao)
            : [],
          situacaoMae: maeDescSI ? maeDescSI.nome : "",
          situacaoPai: paiDescSI ? paiDescSI.nome : "",
        });
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [id, setFiliacao]);

  const FocusError = () => {
    const { errors, isSubmitting, isValidating } = useFormikContext();

    useEffect(() => {
      if (isSubmitting && !isValidating) {
        let keys = Object.keys(errors);
        if (keys.length > 0) {
          const selector = `[name=${keys[0]}]`;
          const errorElement = document.querySelector(selector);
          if (errorElement) {
            errorElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            errorElement.focus({ preventScroll: true });
          }
        }
      }
    }, [errors, isSubmitting, isValidating]);

    return null;
  };

  const FocusErrorDuplicidade = () => {
    const { values } = useFormikContext();
    const { editarCriancaCr } = useAppContext();

    useEffect(() => {
      const validateDateDuplicidade = () => {
        const {
          dataNascimento,
          genero,
          nome,
          nomeSocial,
          nomeNaoInformado,
          idGenero,
        } = values;

        const valuesToSendValid = {
          nome: nome ? nome.trim() : "",
          nomeSocial: nomeSocial ? nomeSocial.trim() : "",
          idCrianca: Number(id),
          idGenero: idGenero ? idGenero.id : "",
          indicadorNomeNaoInformado:
            nomeNaoInformado.length > 0 || nomeNaoInformado === "S" ? "S" : "N",
          nomeUsuarioLogado: `${
            !!keycloak.user.profile?.name ? keycloak.user.profile?.name : ""
          }`,
          dataNascimento:
            dataNascimento &&
            dataNascimento.length === 10 &&
            isValid(parse(dataNascimento, "dd/MM/yyyy", new Date()))
              ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
              : "",
        };

        if (
          editarCriancaCr &&
          dataNascimento &&
          dataNascimento.length === 10 &&
          genero &&
          ((nome && nome.length > 0) || (nomeSocial && nomeSocial.length > 0))
        ) {
          CriancaService.validCrianca(valuesToSendValid).catch((error) => {
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message,
              icon: "warning",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            }).then((result) => {
              history.push(`/crianca`);
            });
          });
        }
      };

      validateDateDuplicidade();
    }, [
      editarCriancaCr,
      values,
      values.dataNascimento,
      values.genero,
      values.nome,
      values.nomeSocial,
      values.nomeNaoInformado,
    ]);

    return null;
  };

  const onKeyDown = (keyEvent) => {
    if (keyEvent.code === "Enter" || keyEvent.code === "NumpadEnter") {
      keyEvent.preventDefault();
    }
  };

  const schema = Yup.object().shape(
    {
      foto: Yup.mixed()
        .nullable()
        .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
          if (value === null) {
            return true;
          } else {
            return value.size <= 10000000;
          }
        })
        .test("imageType", "Anexar uma extensão válida.", (value) => {
          if (value === null) {
            return true;
          } else {
            return suportedImageFormats.includes(value.type);
          }
        }),
      nome: Yup.string()
        .trim()
        .when("nomeSocial", {
          is: (nomeSocial) => !nomeSocial || nomeSocial.trim() === "",
          then: Yup.string().required("Este campo é obrigatório!"),
          otherwise: Yup.string(),
        }),
      nomeSocial: Yup.string()
        .trim()
        .when("nomeNaoInformado", {
          is: (nomeNaoInformado) =>
            nomeNaoInformado && nomeNaoInformado.length > 0,
          then: Yup.string().required("Este campo é obrigatório!"),
          otherwise: Yup.string(),
        }),
      idGenero: Yup.object().nullable().required("Este campo é obrigatório!"),
      nomeNaoInformado: Yup.array().test(
        "naoInformado",
        "Este campo é obrigatório!",
        function (value) {
          const { nomeSocial, nome } = this.parent;
          if (!nome && nomeSocial) {
            return value.length > 0;
          }
          return true;
        },
      ),
      dataNascimento: Yup.string("Este campo é obrigatório!")
        .nullable()
        .required("Este campo é obrigatório!")
        .test("validDate", "", (value) => {
          if (
            value &&
            value.length === 10 &&
            movimentacaoFlag &&
            movimentacaoFlag.dataMovimentacao
          ) {
            const nascimento = parse(value, "dd/MM/yyyy", new Date());
            const movimentacao = new Date(movimentacaoFlag?.dataMovimentacao);

            const umAnoDepois = add(nascimento, { years: 1 });
            movimentacao.setHours(0, 0, 0, 0);
            const dentroUmAno = isWithinInterval(movimentacao, {
              start: nascimento,
              end: umAnoDepois,
            });

            if (dentroUmAno && houveExtincaoPoderFamiliar) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        })
        .test("validDatePendente", "", (value) => {
          if (value && movimentacoesPendente) {
            const birthDate = parse(value, "dd/MM/yyyy", new Date());

            if (isValid(birthDate)) {
              const today = new Date();
              const idade = intervalToDuration({
                start: birthDate,
                end: today,
              })?.years;

              if (idade >= 18) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          } else {
            return true;
          }
        })
        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .test("dataNascimentoAfterToday", "", (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        })
        .when("filiacoes", {
          is: (filiacoes) => {
            return filiacoes.length > 0;
          },
          then: (schema) => {
            return schema.when("filiacoes", (filiacoes, schema) => {
              return schema
                .test(
                  "dataNascimentoAfterFiliacao",
                  "A data informada não pode ser uma data anterior ao nascimento de uma filiação!",
                  (value) => {
                    if (!value) {
                      return true;
                    } else {
                      const found = filiacoes.find((filiacao) => {
                        if (filiacao.dataNascimento) {
                          const parseDate = parse(
                            filiacao.dataNascimento,
                            "dd/MM/yyyy",
                            new Date(),
                          );
                          const tempDataFiliacao = isValid(parseDate)
                            ? parseDate
                            : new Date(filiacao.dataNascimento);
                          return isBefore(
                            parse(value, "dd/MM/yyyy", new Date()),
                            tempDataFiliacao,
                          );
                        } else {
                          return false;
                        }
                      });
                      if (found) {
                        return false;
                      } else {
                        return true;
                      }
                    }
                  },
                )
                .test(
                  "dataNascimentoEqualFiliacao",
                  "A data informada não pode ser igual ao nascimento de uma filiação!",
                  (value) => {
                    if (!value) {
                      return true;
                    } else {
                      const found = filiacoes.find((filiacao) => {
                        if (filiacao.dataNascimento) {
                          return isEqual(
                            parse(
                              filiacao.dataNascimento,
                              "dd/MM/yyyy",
                              new Date(),
                            ),
                            parse(value, "dd/MM/yyyy", new Date()),
                          );
                        } else {
                          return false;
                        }
                      });
                      if (found) {
                        return false;
                      } else {
                        return true;
                      }
                    }
                  },
                );
            });
          },
        })
        .test("dataNascimentoAfterMovimentacao", "", (value) => {
          if (!value) {
            return true;
          } else {
            const dataMovimentacaoFormatada = new Date(
              parseInt(dataMovimentacao),
            );
            const parts = value.split("/");
            const dataNascimentoFormatada = new Date(
              parts[2],
              parts[1] - 1,
              parts[0],
            );

            if (isAfter(dataNascimentoFormatada, dataMovimentacaoFormatada)) {
              return false;
            } else {
              return true;
            }
          }
        }),
      dataFoto: Yup.string()
        .nullable()
        .test("dataFotoAfterToday", "", (value) => {
          if (value === null) {
            return false;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        })
        .test("notBeforeBirthDate", "", function (value) {
          const { dataNascimento } = this.parent;
          const dataFoto = parse(value, "dd/MM/yyyy", new Date());

          if (value && dataNascimento) {
            if (
              isValid(dataFoto) &&
              isValid(parse(dataNascimento, "dd/MM/yyyy", new Date()))
            ) {
              return !isBefore(
                dataFoto,
                parse(dataNascimento, "dd/MM/yyyy", new Date()),
              );
            } else {
              return false;
            }
          } else {
            return true;
          }
        })
        .when("foto", {
          is: (fotoPresente) =>
            !!fotoPresente ||
            (defaultFoto && defaultImage) ||
            (removeu && defaultImage),
          then: Yup.string()
            .required("Este campo é obrigatório!")
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
          otherwise: Yup.string().test(
            "validDate",
            "Data inválida!",
            (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return true;
              }
            },
          ),
        }),
      idRaca: Yup.object().nullable().required("Este campo é obrigatório!"),
      nacionalidade: Yup.mixed(),
      idNaturalidade: Yup.mixed(),
      tipoSanguineo: Yup.mixed(),
      filiacoes: Yup.array()
        .max(4, "Máx. 4 filiações")
        .test("isEmpty", "Este campo é obrigatório!", (value) => {
          return !!value.length;
        })
        .test("hasPai", "Este campo é obrigatório!", (value) => {
          if (value.length) {
            const filiacaoPai = value.find(
              (filiacao) => filiacao.tipoFiliacao === "Pai",
            );
            if (!!filiacaoPai) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .test("hasMae", "Este campo é obrigatório!", (value) => {
          if (value.length) {
            const filiacaoPai = value.find(
              (filiacao) => filiacao.tipoFiliacao === "Mãe",
            );
            if (!!filiacaoPai) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        }),
    },
    [["nome", "nomeSocial"]],
  );

  const handleSubmit = (values, actions) => {
    setLoadingButton(true);
    setTimeout(async () => {
      const {
        foto,
        nome,
        nomeFicticio,
        nomeSocial,
        nomeNaoInformado,
        idGenero,
        genero,
        dataNascimento,
        dataNascimentoEstimada,
        dataFoto,
        idRaca,
        nacionalidade,
        idNaturalidade,
        tipoSanguineo,
        filiacoes,
      } = values;

      const filiacoesTemp = await Promise.all(
        filiacoes.map(async (filiacao) => {
          const nameImage = filiacao?.arquivoBase64?.name;
          const typeImage = filiacao?.arquivoBase64?.type;

          if (filiacao.arquivoBase64 instanceof File) {
            await new Promise((resolve) => {
              getBase64(filiacao.arquivoBase64, (base64Data) => {
                filiacao.arquivoBase64 = base64Data;
                resolve();
              });
            });
          }

          const anexoCertidaoObito = {
            arquivoBase64: filiacao?.arquivoBase64
              ? filiacao?.arquivoBase64.split(",")[1]
              : filiacao?.possuiAnexoCertidaoObito && filiacao?.removeu
                ? filiacao?.certidaoObito?.arquivoBase64.split(",")[1]
                : "",
            arquivoNome: nameImage ? nameImage : "",
            arquivoTipo: typeImage ? typeImage : "",
            idAnexo: !filiacao?.possuiAnexoCertidaoObito
              ? 0
              : filiacao?.possuiAnexoCertidaoObito && filiacao?.removeu
                ? filiacao?.certidaoObito?.idAnexo
                : filiacao?.possuiAnexoCertidaoObito && !filiacao?.removeu
                  ? filiacao?.certidaoObito?.idAnexo
                  : 0,
          };

          const isFalecido =
            filiacao?.falecido === "S" || filiacao?.falecido?.id === 1;
          const naoFalecido =
            !filiacao?.falecido ||
            filiacao?.falecido === "N" ||
            filiacao?.falecido?.id === 2;

          if (filiacao?.arquivoBase64 && isFalecido) {
            anexoCertidaoObito.remover = false;
            anexoCertidaoObito.atualizar = true;
          } else if (
            filiacao?.possuiAnexoCertidaoObito &&
            isFalecido &&
            filiacao?.removeu &&
            !filiacao?.arquivoBase64
          ) {
            anexoCertidaoObito.remover = true;
            anexoCertidaoObito.atualizar = true;
          } else if (filiacao?.possuiAnexoCertidaoObito && naoFalecido) {
            anexoCertidaoObito.arquivoBase64 = "";
            anexoCertidaoObito.remover = true;
            anexoCertidaoObito.atualizar = true;
          } else {
            anexoCertidaoObito.remover = false;
            anexoCertidaoObito.atualizar = false;
          }

          const {
            id,
            local,
            tipoFiliacao,
            nome,
            dataNascimento,
            falecido,
            cpf,
            numeroIdentidade,
            email,
            informacoesComplementares,
            idEstado,
            idMunicipio,
            idBairro,
            logradouro,
            complemento,
            pontoReferencia,
            ...resto
          } = filiacao;

          if (filiacao.local) {
            const returnObject = {
              ...resto,
              anexoCertidaoObito: anexoCertidaoObito ? anexoCertidaoObito : "",
              tipoFiliacao: tipoFiliacao ? tipoFiliacao : "",
              nome: nome ? nome.trim() : "",
              dataNascimento: dataNascimento
                ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
                : "",
              falecido: falecido === "S" ? "S" : falecido === "N" ? "N" : null,
              cpf: cpf ? cpf.replace(/[.-]/g, "").trim() : "",
              numeroIdentidade: numeroIdentidade ? numeroIdentidade.trim() : "",
              email: email ? email.trim() : "",
              informacoesComplementares: informacoesComplementares
                ? informacoesComplementares.trim()
                : "",
              idEstado: idEstado ? idEstado.id : "",
              idMunicipio: idMunicipio ? idMunicipio.id : "",
              idBairro: idBairro ? idBairro.id : "",
              logradouro: logradouro ? logradouro.trim() : "",
              complemento: complemento ? complemento.trim() : "",
              pontoReferencia: pontoReferencia ? pontoReferencia.trim() : "",
            };

            delete returnObject.arquivoBase64;
            delete returnObject.possuiAnexoCertidaoObito;
            delete returnObject.removeu;
            delete returnObject.certidaoObito;
            delete returnObject.criancasAgrupadas;

            return returnObject;
          } else {
            const returnObject = {
              ...filiacao,
              anexoCertidaoObito: anexoCertidaoObito ? anexoCertidaoObito : "",
              cpf: cpf ? cpf.replace(/[.-]/g, "").trim() : "",
              idEstado: filiacao.idEstado
                ? filiacao.idEstado.id
                : filiacao.estado
                  ? filiacao.estado.id
                  : "",
              idMunicipio: filiacao.idMunicipio
                ? filiacao.idMunicipio.id
                : filiacao.municipio
                  ? filiacao.municipio.id
                  : "",
              idBairro: filiacao.idBairro
                ? filiacao.idBairro.id
                : filiacao.bairro
                  ? filiacao.bairro.id
                  : "",
              falecido:
                filiacao?.falecido === "S" || filiacao?.falecido?.id === 1
                  ? "S"
                  : filiacao?.falecido === "N" || filiacao?.falecido?.id === 2
                    ? "N"
                    : null,
              dataNascimento: filiacao.dataNascimento
                ? isValid(filiacao.dataNascimento)
                  ? new Date(filiacao.dataNascimento).toISOString()
                  : parse(
                      filiacao.dataNascimento,
                      "dd/MM/yyyy",
                      new Date(),
                    ).toISOString()
                : "",
            };

            delete returnObject.arquivoBase64;
            delete returnObject.possuiAnexoCertidaoObito;
            delete returnObject.removeu;
            delete returnObject.certidaoObito;
            delete returnObject.criancasAgrupadas;
            return returnObject;
          }
        }),
      );

      const valuesToSend = {
        crianca: {
          id: id,
          anexos: null,
          dataCadastro: null,
          dataNascimento: dataNascimento
            ? parse(dataNascimento, "dd/MM/yyyy", new Date()).toISOString()
            : "",
          dataNascimentoEstimada: dataNascimentoEstimada ? "S" : "N",
          nomeFicticio: nomeFicticio && nomeFicticio.length > 0 ? "S" : "N",
          nomeNaoInformado:
            nomeNaoInformado && nomeNaoInformado.length > 0 ? "S" : "N",
          genero: idGenero.id
            ? {
                idGenero: idGenero?.id,
                descricao: idGenero?.descricao,
                genero: idGenero?.genero,
              }
            : genero,

          movimentacoes: null,
          dataFoto: dataFoto
            ? parse(dataFoto, "dd/MM/yyyy", new Date()).toISOString()
            : "",
          nacionalidade: {
            idNacionalidade: nacionalidade?.id
              ? nacionalidade?.id
              : nacionalidade?.idNacionalidade,
            nacionalidade: nacionalidade?.nacionalidade,
          },
          naturalidade: idNaturalidade ? idNaturalidade : null,
          nome: nome ? nome.trim() : "",
          nomeSocial: nomeSocial ? nomeSocial.trim() : "",
          raca: idRaca ? idRaca : "",
          removerFoto:
            idAnexoFoto && !foto && defaultImage === "" ? true : false,
          idAnexoFoto: idAnexoFoto,
          tipoSanguineo: tipoSanguineo
            ? {
                idTipoSanguineo:
                  tipoSanguineo?.id || tipoSanguineo?.idTipoSanguineo,
                tipoSanguineo: tipoSanguineo.tipoSanguineo,
              }
            : null,
          ultimaAtualizacao: null,
          nomeUsuarioLogado: `${
            !!keycloak.user.profile?.name ? keycloak.user.profile?.name : ""
          }`,
        },
        filiacoes: filiacoesTemp,
      };

      CriancaService.editarCrianca(id, valuesToSend)
        .then((res) => {
          if (!!foto) {
            try {
              CriancaService.postFotoCriancaPerfil(
                res.data,
                foto,
                dataFoto
                  ? format(
                      parse(dataFoto, "dd/MM/yyyy", new Date()),
                      "yyyy-MM-dd",
                    )
                  : "",
                idAnexoFoto && !foto ? idAnexoFoto : 0,
              );
            } catch (error) {
              console.error("Erro ao alterar foto da Crianca", error);
            }
          }
          setLoadingButton(false);
          setTimeout(() => {
            history.push("/crianca/" + res.data);
            setEditarCriancaCr(false);
            Swal.fire({
              title: "Sucesso!",
              text: "Registro atualizado com sucesso!",
              icon: "success",
              confirmButtonText: "Continuar",
              confirmButtonColor: "#169499",
            }).then(function () {});
          }, 0);
        })
        .catch((error) => {
          setLoadingButton(false);
          let dataNascimentoError;
          let cpfError;
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (
                  error.response.data.field === "criancaDTO" ||
                  error.response.data.field === "Criança" ||
                  error.response.data.field === "errors"
                ) {
                  if (error.response.data.field === "errors") {
                    dataNascimentoError = JSON.parse(
                      error?.response?.data.message,
                    )?.dataNascimento;
                    cpfError = JSON.parse(error?.response?.data.message)?.cpf;
                  }

                  Swal.fire({
                    title: "Atenção!",
                    text: dataNascimentoError
                      ? dataNascimentoError
                      : cpfError
                        ? cpfError
                        : error.response.data.message
                          ? error.response.data.message
                          : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  });
                } else {
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message,

                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  });
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(
                      erro.field
                        .toString()
                        .slice(erro.field.toString().indexOf(".") + 1),
                      erro.message,
                    );
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
        });

      actions.setSubmitting(false);
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack?.includes(criancaFunc.editar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(
          dataCrianca?.servicoAcolhimento?.idPessoaJuridica,
        ))) ? (
    <Flex flex={1} flexDir="column" alignItems="center" overflow="auto">
      {!loading ? (
        <Flex flexDir="column" w="100%">
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize
          >
            {(props) => {
              let propsValuesCorrect = { ...props.values };

              if (
                propsValuesCorrect.nacionalidade &&
                propsValuesCorrect.nacionalidade.id
              ) {
                propsValuesCorrect.nacionalidade = {
                  idNacionalidade: propsValuesCorrect.nacionalidade.id,
                  nacionalidade: propsValuesCorrect.nacionalidade.nacionalidade,
                };
              }

              return (
                <Form onKeyDown={onKeyDown}>
                  {setEditarCriancaCr(
                    hasFormChanged(initialValues, propsValuesCorrect),
                  )}
                  {setFoto(props.values.foto)}
                  <FocusError />
                  <FocusErrorDuplicidade />
                  <Identificacao
                    dataMovimentacao={dataMovimentacao}
                    dataMovimentacaoFlag={movimentacaoFlag}
                    defaultImage={defaultImage}
                    defaultFoto={defaultFoto}
                    removeu={removeu}
                    setRemoveu={setRemoveu}
                    setDefaultImage={setDefaultImage}
                    idAnexoFoto={idAnexoFoto}
                    idAnexo={idAnexo}
                    idTipoPendencia={idTipoPendencia}
                    scrollToField={scrollToField}
                  />
                  <Field name={"filiacoes"}>
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={
                          form.errors.filiacoes && form.touched.filiacoes
                        }
                        id={"filiacoes"}
                      >
                        <Filiacao
                          filiacoes={props.values.filiacoes}
                          idCrianca={id}
                          idAnexo={idAnexo}
                          idTipoPendencia={idTipoPendencia}
                          idPJ={
                            dataCrianca?.servicoAcolhimento?.idPessoaJuridica
                          }
                          scrollToField={scrollToField}
                        />
                        <FormErrorMessage>
                          {form.errors.filiacoes}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                  <Flex justifyContent="flex-end">
                    <Button
                      type="submit"
                      translate="no"
                      mt="30px"
                      px="45px"
                      h="42px"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      disabled={loadingButton}
                      _hover={{ bg: "#169499" }}
                      isLoading={props.isSubmitting || loadingButton}
                    >
                      Salvar
                    </Button>
                  </Flex>
                </Form>
              );
            }}
          </Formik>
        </Flex>
      ) : (
        <LoadingSpinner />
      )}
    </Flex>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
